var $be9d354476c08087$exports = {};
$be9d354476c08087$exports = {
  "removeButtonLabel": "Supprimer",
  "removeDescription": "Appuyez sur Supprimer pour supprimer l\u2019\xE9tiquette."
};
export { $be9d354476c08087$exports as default };